var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("all-payments-table", {
        attrs: {
          value:
            _vm.filter === "future"
              ? _vm.futureAllPayments
              : _vm.todaysAllPayments,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("more-info", {
            attrs: { moreInfo: _vm.moreInfo.allPayments },
            on: { click: _vm.moreInfoOpen },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }